import { Component } from 'angular-ts-decorators';

import { IconDefinition, faClipboard } from '@fortawesome/pro-solid-svg-icons';
import {
  NotificationManager,
  Notification,
} from '@shared/app/scripts/services/notification-manager';

/**
 * Component displaying all messages available in the notificationManager service.
 *
 * # Example
 * <pre>
 *   <sw-notification-center></sw-notification-center>
 * </pre>
 */
@Component({
  selector: 'swNotificationCenter',
  template: require('./sw-notification-center.html').default,
})
export class SwNotificationCenterComponent {
  faClipboard: IconDefinition = faClipboard;
  notifications: Notification[];

  constructor(notificationManager: NotificationManager) {
    'ngInject';

    this.notifications = notificationManager.collection;
  }
}
